// extracted by mini-css-extract-plugin
module.exports = {"submit":"AccountCreatingForm_submit_2KLqC","primary":"AccountCreatingForm_primary_2VH3y"};